import { Maskito } from './vendor/@maskito/core/index.esm.js';
import {
    maskitoAddOnFocusPlugin,
    maskitoCaretGuard,
    maskitoPrefixPostprocessorGenerator,
    maskitoRemoveOnBlurPlugin,
} from './vendor/@maskito/kit/index.esm.js';

export default (element) => {
    return new Maskito(element, {
        mask: ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/,],
        postprocessors: [
            // non-removable country prefix
            maskitoPrefixPostprocessorGenerator('+7 '),
        ],
        preprocessors: [
            createCompletePhoneInsertionPreprocessor()
        ],
        plugins: [
            maskitoAddOnFocusPlugin('+7 '),
            maskitoRemoveOnBlurPlugin('+7 '),
            maskitoCaretGuard((value, [from, to]) => [
                from === to ? '+7 '.length : 0,
                value.length,
            ]),
        ],
    });

    function createCompletePhoneInsertionPreprocessor() {
        const trimPrefix = (value) => value.replace(/^(\+?7?\s?8?)\s?/, '');
        const countDigits = (value) => value.replace(/\D/g, '').length;

        return ({elementState, data}) => {
            const {value, selection} = elementState;

            return {
                elementState: {
                    selection,
                    value: countDigits(value) > 11 ? trimPrefix(value) : value,
                },
                data: countDigits(data) >= 11 ? trimPrefix(data) : data,
            };
        };
    }
}

